import React from 'react';
import {observer} from 'mobx-react'
import BaseBindedComponent, { BaseBindedComponentProps, BaseBindedComponentState } from '../base-components/BaseBindedComponent'
import ComponentOuterDiv from "./ComponentOuterDiv";
import { IDomainData, IUISwitchColDef, IUISwitchDef } from '../../datatypes';
import { DomainAttrInUIComponentProps } from './BaseUIComponent';
import { toBoolean } from '../../utils/config-utils';

const {MDBSwitch} = require('mdbreact');

interface SwitchProps extends BaseBindedComponentProps {
    /** @override */
    metadata: IUISwitchDef|IUISwitchColDef;

    /** @override */
    domainAttribute:DomainAttrInUIComponentProps;    
}

class Switch extends BaseBindedComponent<SwitchProps, BaseBindedComponentState> {
    
  render() {
    const props = this.props as SwitchProps & {[key:string]:IDomainData};  
    const {
      properties,
      label,
      disabled,
      readonly,
      cssClasses,
      componentId
    } = this.props.metadata;

    let width, labelPosition:string|undefined;
    switch(props.metadata.type){
        case 'Switch': labelPosition = props.metadata.labelPosition; break;
        case 'SwitchCol': width = props.metadata.width; break;
    }

    let {xs, sm, md, lg} = properties||{};
    let {domainAttribute}= this.props;
    let value = props[domainAttribute.objectName][domainAttribute.name] as string;
    let readonlyClass = readonly ? ' ui-switch-readonly' : ''
    let disabledClass = disabled ? ' ui-switch-disabled' : ''
    let className = 'ui-renderer-switch '+ ((cssClasses ? cssClasses : '') + disabledClass + readonlyClass);
    let hasError = !!this.props.error;
    className += hasError ? ' is-invalid ' : '';
    className += labelPosition === 'LEFT' ? ' ui-switch-left ' : ' ui-switch-right ';
    let id = domainAttribute.namePrefix + componentId
    id = (id.charAt(0).toLowerCase() + id.slice(1)).replace(/\./g, "-");
    let domainDataType = this.props.domainAttribute.domainDataType;
    let valueForChecked = domainDataType === 'Number' || domainDataType === 'Boolean' ? 1 : 'Y';
    let calculatedLabel = this.props.dataGridField ? ' ' : label;
    let valueForNotChecked = domainDataType === 'Number' || domainDataType === 'Boolean' ? 0 : 'N';

    return (
        <ComponentOuterDiv width={width} dataGridField={!!this.props.dataGridField} xs={xs} sm={sm} md={md} lg={lg}>
          <div className={"ui-renderer-switch-outer-div"}>
          <MDBSwitch
              disabled={disabled}
              error={this.props.error}
              id={id}
              labelLeft={labelPosition === "LEFT" ? calculatedLabel : ""}
              labelRight={labelPosition === "RIGHT" ? calculatedLabel : ""}
              checked={toBoolean(value)}
              className={className}
              onChange={(e: { target: { checked: boolean; }; })=>this.onChangeHandler(e.target.checked === true ? valueForChecked : valueForNotChecked , true)}
          />
          <div className={"invalid-feedback"} style={{display: hasError ? 'block': 'none'}}>{this.props.error}</div>
          </div>
        </ComponentOuterDiv>
    )
  }
}

export default observer (Switch);